import { render, staticRenderFns } from "./Integral.vue?vue&type=template&id=b8c9a564&scoped=true&"
import script from "./Integral.vue?vue&type=script&lang=js&"
export * from "./Integral.vue?vue&type=script&lang=js&"
import style0 from "./Integral.vue?vue&type=style&index=0&id=b8c9a564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c9a564",
  null
  
)

export default component.exports